import { DialogBaseProps } from '@optimus-web/core';
import { useToggle } from './useToggle';

export const useDialog = () => {
    const [open, toggleOpen] = useToggle();

    return [{ active: open, onClose: toggleOpen }, toggleOpen] satisfies [DialogBaseProps, () => void];
};
